// extracted by mini-css-extract-plugin
module.exports = {"bgPublic":"MainContainer_bgPublic__1PMnR","bgPrivate":"MainContainer_bgPrivate__2BD71"};